import { Routes } from '@angular/router';
import { AppComponent } from './app.component';

export const routes: Routes = [
	{ path: 'de', component: AppComponent },
	{ path: 'en', component: AppComponent },

	{ path: '**', redirectTo: '/de', pathMatch: 'full' }
];
